import { Injectable, TemplateRef } from "@angular/core";
import { Subject } from 'rxjs';

import notify from 'devextreme/ui/notify';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    /**
    *
    */
    public toastObserver: Subject<ToastSettings> = new Subject<ToastSettings>();

    constructor() { }

    /**
     * Show a toast-message at the bottom of the screen
     * @param text The text to show
     * @param type The type of the toast
     * @param timeToShowMs Time to show the toast (in milliseconds)
     */
    public showToast(text: string, type: ToastType, timeToShowMs: number = 1500) {

        notify(text, ToastType[type], timeToShowMs);

        //let settings = new ToastSettings(text, type, 50000);
        //this.toastObserver.next(settings);
    }
}

export class ToastSettings {

    public type: string;

    constructor(public text: string, private toastType: ToastType, public timeToShowMs: number = 1500) {
        this.type = ToastType[toastType];
    }
}

export enum ToastType {
    info,
    warning,
    error,
    success
}
